import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "send-to-partner-box" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_3 = { style: {"max-width":"500px"} }
const _hoisted_4 = { class: "d-flex justify-content-center mb-20" }
const _hoisted_5 = { class: "text-center confirm-modal-title" }
const _hoisted_6 = { class: "d-flex flex-column mt-40" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "confirm-modal-label" }, "Partner Name: ", -1)
const _hoisted_8 = { class: "confirm-modal-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SendSummaryBox = _resolveComponent("SendSummaryBox")!
  const _component_AdminReviewSentRequestQuestionAnswer = _resolveComponent("AdminReviewSentRequestQuestionAnswer")!
  const _component_white_box_main = _resolveComponent("white-box-main")!
  const _component_LoadingSvg = _resolveComponent("LoadingSvg")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    default: _withCtx(() => [
      _createVNode(_component_white_box_main, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.haveAnswers)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_SendSummaryBox, {
                    edited: _ctx.userResponseTypes.edited,
                    approved: _ctx.userResponseTypes.approved,
                    rejected: _ctx.userResponseTypes.rejected,
                    onOnSendSummary: _ctx.confirmModal.open
                  }, null, 8, ["edited", "approved", "rejected", "onOnSendSummary"])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, ix) => {
              return (_openBlock(), _createBlock(_component_AdminReviewSentRequestQuestionAnswer, {
                key: question.id,
                ix: ix,
                question: question,
                "is-active": _ctx.isQuestionActive(question.id),
                error: '',
                count: ix,
                "question-response-state": _ctx.questionResponsesState,
                onHandleValueUpdate: _ctx.handleValueUpdate,
                onSetQuestionResponseState: _ctx.setQuestionResponseState,
                onHandleReviewQuestion: _ctx.handleReviewQuestion
              }, null, 8, ["ix", "question", "is-active", "count", "question-response-state", "onHandleValueUpdate", "onSetQuestionResponseState", "onHandleReviewQuestion"]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.confirmModal.isOpen.value,
        onOnCancel: _ctx.confirmModal.close,
        onOnConfirm: _ctx.completeReview
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_LoadingSvg)
            ]),
            _createElementVNode("h4", _hoisted_5, "Send Summary to Partner " + _toDisplayString(_ctx.entireServerResponse.name) + "?", 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.entireServerResponse.name), 1)
              ])
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, { onClick: _ctx.completeReview }, {
            default: _withCtx(() => [
              _createTextVNode("Send summary")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_base_button, {
            variant: "outlined",
            class: "mr-20",
            onClick: _ctx.confirmModal.close
          }, {
            default: _withCtx(() => [
              _createTextVNode("Don't send go back")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["is-visible", "onOnCancel", "onOnConfirm"])
    ]),
    _: 1
  }))
}